// extracted by mini-css-extract-plugin
export default {"tooltip":"rp-z","sharingV2":"sp-z","sharingIconsV2":"tp-z","links":"up-z","link":"vp-z","facebookV2":"wp-z","twitterV2":"xp-z","pinterestV2":"yp-z"};